import React from 'react'
import UserResults from '../components/users/UserResults'
import Usersearch from '../components/users/Usersearch'

function Home() {
  return (
    <>
      <Usersearch/>
      <UserResults/>
    </>
  )
}

export default Home
